module.exports = __webpack_public_path__ + "static/img/wx_bj_jcjg.png";